module.exports = __webpack_public_path__ + "static/media/mobile-app-en.4e59e5a3.jpg";